export default {
  casapi: process.env.VUE_APP_CASAPI,
  bapi: process.env.VUE_APP_BAPI,
  env: process.env,
};
